import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getProfileInfo } from "services";
import { GitHubProfile } from "shared/interfaces";
import * as S from "./style";
import { Introduction, Skills, SocialMedia, Wellcome } from "./components";

const Home = () => {
  const { t, i18n } = useTranslation("home");
  const [userInfo, setUserInfo] = useState<Partial<GitHubProfile>>({});

  useEffect(() => {
    const setUser = async () => {
      const gitHubUser = await getProfileInfo();
      if (gitHubUser) {
        setUserInfo(gitHubUser);
      }
    };

    setUser();
  }, []);

  useEffect(() => {
    document.title = t("pageTitle");
    const description = document.querySelector('meta[name="description"]');
    description?.setAttribute("content", t("pageDescription"));
  }, [i18n.language, t]);

  return (
    <S.Page>
      <S.Header>
        <S.HeaderInner>
          <S.Brand href="#home">João Mago</S.Brand>
          <S.Navigation aria-label={t("navigationLabel")}>
            <S.NavigationLink href="#about">
              {t("navigationAbout")}
            </S.NavigationLink>
            <S.NavigationLink href="#skills">
              {t("navigationSkills")}
            </S.NavigationLink>
            <S.NavigationLink href="#contact">
              {t("navigationContact")}
            </S.NavigationLink>
            <S.LanguageSelect
              aria-label={t("languageLabel")}
              value={
                i18n.language.toLowerCase().startsWith("pt") ? "ptBr" : "en"
              }
              onChange={(event) => i18n.changeLanguage(event.target.value)}
            >
              <option value="en">English</option>
              <option value="ptBr">Português</option>
            </S.LanguageSelect>
          </S.Navigation>
        </S.HeaderInner>
      </S.Header>

      <main>
        <S.Hero id="home">
          <S.Content>
            <Wellcome />
          </S.Content>
        </S.Hero>

        <S.Section id="about" $color="lightBg">
          <S.Content>
            <Introduction userInfo={userInfo} />
          </S.Content>
        </S.Section>

        <S.Section id="skills" $color="grayBg">
          <S.Content>
            <Skills />
          </S.Content>
        </S.Section>

        <S.Section id="contact">
          <S.Content>
            <SocialMedia />
          </S.Content>
        </S.Section>
      </main>
    </S.Page>
  );
};

export default Home;
